// extracted by mini-css-extract-plugin
export default {"Board":"board_Board__SgD4f"};